import { BoxPlotDataUtil } from '../../data-mapper';
import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { BaseChartWorker } from '../common';

/**
 * BoxPlotChartWorker: chart worker specific to a Box Plot Chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class BoxPlotChartWorker extends BaseChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
	}

	public transformData(): void {
		const seriesData = [];
		this.highChartsAttributes.tabData.tableData.forEach(table => {
			const seriesDataItem = BoxPlotDataUtil.getDataByPercentileAttribute(table, this.highChartsAttributes.portfolioIndex);
			seriesData.push(seriesDataItem);
		});

		const scatterValue: number = <number>(this.highChartsAttributes.tabData.tableData[0].cells[this.highChartsAttributes.portfolioIndex][0].rawValue);
		this.config.series[0].data = seriesData;
		this.config.series[1].data = [[3, scatterValue]];
		this.config.series[1].color = this.highChartsAttributes.colors[0];
		this.config['tooltip'].enabled = false;
	}
}
